import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { WorkflowUrlParams } from '@warema/shared/models';
import { first } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class WorkflowUrlService {
    private readonly _activatedRoute = inject(ActivatedRoute);
    private readonly _router = inject(Router);

    public productConfigurationId = '';
    public projectName = '';

    constructor() {
        this._activatedRoute.queryParamMap.pipe(first()).subscribe((paramsMap: ParamMap) => {
            this.productConfigurationId = paramsMap.get(WorkflowUrlParams.ProjectConfigurationId) ?? '';
            this.projectName = paramsMap.get(WorkflowUrlParams.ProjectName) ?? '';
        });
    }

    public async navigateToOfferConfirmation(companyName: string): Promise<void> {
        await this._router.navigate(['confirmation'], {
            queryParams: {
                [WorkflowUrlParams.ProjectConfigurationId]: this.productConfigurationId,
                [WorkflowUrlParams.ProjectName]: this.projectName,
                dealerName: companyName,
            },
            queryParamsHandling: 'merge',
            relativeTo: this._activatedRoute,
        });
    }
}
